export default "__VITE_ASSET__D5lG8rU$__"